import { useLoaderStore } from '../store/loader';

export default defineNuxtPlugin((nuxtApp) => {
  const loaderStore = useLoaderStore();
  nuxtApp.provide('spinner', {
    startProgress() {
      loaderStore.startProgress();
      //nuxtApp.$store.commit('loader/startProgress')
    },
    stopProgress() {
      loaderStore.stopProgress();
      //nuxtApp.$store.commit('loader/stopProgress')
    }
  });
});
